import React, { useState } from "react";
import { Form, Input, Button, Row, Col, Modal, Typography, Select,DatePicker,message } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";

const { confirm } = Modal;
const { Title, Text } = Typography;
const { Option } = Select;

const PersonalHoldings = () => {
    const [form] = Form.useForm();
    const history = useHistory();

    const [holdings, setHoldings] = useState([
        { type: "", description: "", value: "", acquisitionDate: "", liabilities: "", insurance: "" }
    ]);

    const addHolding = () => {
        setHoldings([
            ...holdings,
            { type: "", description: "", value: "", acquisitionDate: "", liabilities: "", insurance: "" }
        ]);
    };

    const deleteHolding = (index) => {
        confirm({
            title: "Are you sure you want to delete this personal holding?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk() {
                setHoldings(holdings.filter((_, idx) => idx !== index));
            },
        });
    };

    const onBack = () => {
        history.push(routes.partnershipInterests.path);
    };

    const onNext = () => {
        history.push(routes.liabilitiesForm.path); 
    };

    const onFinish = (values) => {
        console.log("Saved Personal Holdings:", values);
        message.success("Personal Holdings Saved!");
        onNext();
    };

    return (
        <LeftLayout>
            <Row style={{ minHeight: "100vh", background: "#fff" }} align="top" className="rightbox">
                <Col span={24}>
                    <Title level={4} style={{ marginTop: 40 }}>
                        Personal Holdings  
                    </Title>

                    <Form form={form} layout="vertical" onFinish={onFinish}>
                        {holdings.map((_, idx) => (
                            <div key={idx}>
                                <Row justify="space-between" align="middle" style={{ marginTop: 30 }}>
                                    <Col>
                                        <Text strong style={{ fontSize: 16 }}>
                                            Holding {String(idx + 1).padStart(2, "0")}
                                        </Text>
                                    </Col>
                                    <Col>
                                        {idx > 0 && (
                                            <Button
                                                type="text"
                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                onClick={() => deleteHolding(idx)}
                                            />
                                        )}
                                    </Col>
                                </Row>

                                <Form.Item
                                    label="Type Of Asset"
                                    name={["holdings", idx, "type"]}
                                    rules={[{ required: true, message: "Please select asset type" }]}                 
                                    className='w50'
                                >
                                    <Select placeholder="Select">
                                        <Option value="realEstate">Real Estate</Option>
                                        <Option value="vehicle">Vehicle</Option>
                                        <Option value="art">Art</Option>
                                        <Option value="jewelry">Jewelry</Option>
                                        <Option value="other">Other</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label="Description"
                                    name={["holdings", idx, "description"]}
                                    rules={[{ required: true, message: "Please enter description" }]}
                                    className='w50'
                                >
                                    <Input.TextArea rows={3} />
                                </Form.Item>

                                <Form.Item
                                    label="Estimated Value"
                                    name={["holdings", idx, "value"]}
                                    rules={[{ required: true, message: "Please enter estimated value" }]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Date Of Acquisition"
                                    name={["holdings", idx, "acquisitionDate"]}
                                    rules={[{ required: true, message: "Please enter acquisition date" }]}
                                    className='w50'
                                >
                                    <DatePicker style={{ width: "100%" }} placeholder="MM/DD/YYYY" format="MM/DD/YYYY" />
                                </Form.Item>

                                <Form.Item
                                    label="Outstanding Liabilities (If Any)"
                                    name={["holdings", idx, "liabilities"]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Insurance Coverage (If Applicable)"
                                    name={["holdings", idx, "insurance"]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>
                            </div>
                        ))}

                        <Form.Item>
                            <Button
                                type="link"
                                icon={<PlusCircleOutlined />}
                                onClick={addHolding}
                                style={{
                                    padding: 0,
                                    fontWeight: "bold",
                                    color: "#002766",
                                    fontSize: 15,
                                    marginTop: 10,
                                }}
                                className='w50'
                            >
                                Add Another Personal Holding
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                    className='w50'
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className='w50'
                                >
                                    Save And Proceed<RightOutlined />
                                </Button>
                                <Button
                                    type="default"
                                    onClick={onNext}
                                    className='w50'
                                >
                                    Next <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </LeftLayout>
    );
};

export default PersonalHoldings;
